export const WAS_CARD_PAYMENT_INFO_SHOWED_LOCAL_STORAGE_KEY =
  'WAS_CARD_PAYMENT_INFO_SHOWED';
